import React, { useEffect } from "react";

import "../all css/BlogView.css";
import { useLocation } from "react-router-dom";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/footer";
const writeImage = require("../../assets/writes_ideas_svg.svg");
const img_blog = require("../../assets/blogs/blog_poster.jpg");

const allRelatedBlogContent = [
  {
    nameOfBlog: "Decision: Making the choice to Study Abroad",
    extraContentOfBlog: `Study Abroad is an exceptional experience every time. It
    requires a commitment to excellence, intelligent
    planning, and focused efforts. The fabulously planned
    careers are to find space in the minds of the admirers
    and motivate others to work hard for their dreams. Our
    experts will build your dream around you. They Create
    and You Celebrate.`,
    blogImgName: img_blog,
  },
  {
    nameOfBlog: "How to study abroad",
    blogImgName: img_blog,
    extraContentOfBlog: `A student, who wishes to study overseas, is often at a loss when it comes to seeking help for the same. DWEC works towards the most uncomplicated plans to bring ease to this transition`,
  },
  {
    blogImgName: img_blog,
    nameOfBlog: "Australia to reopen its borders from December 1",
    extraContentOfBlog: `Australia announced on Monday that it would ease its strict pandemic-related travel restrictions beginning...`,
  },
];

export default function BlogView() {
  const points = [
    { value: 1 },
    { value: 1 },
    { value: 1 },
    { value: 1 },
    { value: 1 },
    { value: 1 },
  ];

  const { state } = useLocation();

  useEffect(() => {}, [state]);

  return (
    <>
      <div className="nav_container">
        <Navbar fromPage="blogview" />
      </div>

      <div className="bg_img_blog">
        <section className="main_blog_view_container">
          <div className="blog_view_section_under_contianer">
            <div className="blog_view_left_container">
              <img
                src={state.blogCoverImg}
                alt="writeImage"
                className="blog_image"
              />
              <p className="blog_view_date_text">{state.dateBlog}</p>
              <p className="blog_view_title_text">{state.title}</p>
              <hr className="blog_view_line" />
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {points.map(() => {
                  return <div className="blog_points" key={Math.random()} />;
                })}
              </div>

              <div
                className="blog_view_first_para"
                dangerouslySetInnerHTML={{
                  __html: state.longDescription,
                }}
              ></div>
            </div>
            <div className="blog_right_view_container">
              <div className="blog_under_right_view_container">
                <p className="blog_view_title_txt">Recent Blogs</p>
                <hr />
                {allRelatedBlogContent.map((perRelatedBlog) => {
                  return (
                    <div
                      className="right_view_content_contianer"
                      key={Math.random()}
                    >
                      <a href="blog" className="blog_view_heading_text">
                        {perRelatedBlog.nameOfBlog}
                      </a>
                      <div className="img_for_blog_container">
                        <img src={perRelatedBlog.blogImgName} alt="img_blog" />
                      </div>
                      <p className="extra_content_blog_view_text">
                        {perRelatedBlog.extraContentOfBlog}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}
